export function fmtMonthYear(d) {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt)) return String(d);
  return dt.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}

export function rankTier(n) {
  const t = Number(n);
  if (!isFinite(t)) return { label: '—', tier: null };
  if (t === 1) return { label: 'Tier 1 — Top flight', tier: 1 };
  if (t === 2) return { label: 'Tier 2', tier: 2 };
  if (t === 3) return { label: 'Tier 3', tier: 3 };
  if (t >= 4) return { label: `Tier ${t}`, tier: t };
  return { label: '—', tier: null };
}

export function tierLabel(n) {
  const t = Number(n);
  if (!isFinite(t)) return '—';
  const ord = t === 1 ? '1st' : t === 2 ? '2nd' : t === 3 ? '3rd' : `${t}th`;
  return `${ord} Tier`;
}

export function leagueTier(d) {
  const m = String(d?.name || '').match(/^(\d+)\.?\s/);
  if (m && m[1]) return tierLabel(m[1]);
  const c = Number(d?.category);
  if (c >= 1 && c <= 6) return tierLabel(c);
  return 'Top flight';
}

export function seasonStatus(season) {
  if (!season) return { label: '—', status: null };
  if (season.is_current && !season.finished) return { label: 'Live', status: 'live' };
  if (season.finished) return { label: 'Finished', status: 'finished' };
  return { label: 'Upcoming', status: 'upcoming' };
}

export function titleize(str) {
  if (!str) return '';
  return String(str).replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
